var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIconSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.30476 8.71879C4.92309 9.09374 4.28621 9.09374 3.90454 8.71879L0.285352 5.16334C-0.0951174 4.78957 -0.0951174 4.1676 0.285352 3.79383L1.07024 3.02277C1.45167 2.64805 2.06622 2.64781 2.44794 3.02206L4.61424 5.13137L9.55134 0.281214C9.93301 -0.093738 10.5481 -0.093738 10.9298 0.281214L11.7146 1.05228C12.0951 1.42604 12.0951 2.04802 11.7146 2.42178L5.30476 8.71879Z",
    fill: "#9E9288"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIconSm);
export default __webpack_public_path__ + "static/media/checked-icon-sm.3732a6d72bf7954ec334e563231b9882.svg";
export { ForwardRef as ReactComponent };